// extracted by mini-css-extract-plugin
export var homeBanner = "home-banner-module--home-banner--2-K8k";
export var intro = "home-banner-module--intro--AsY0I";
export var videoBackground = "home-banner-module--video-background--OEHe8";
export var inBriefBtn = "home-banner-module--in-brief-btn--yrIOn";